const aiTen = [
  {
      "name": "剪映",
      "url": "https://www.capcut.com",
      "icon": "images/jianying.jpg",
      "description": "全能易用的桌面端剪辑软件"
  },
  {
      "name": "Clipchamp",
      "url": "https://clipchamp.com",
      "icon": "images/clipchamp.png",
      "description": "国外一款在线剪辑工具"
  },
  {
      "name": "快剪辑",
      "url": "https://kuai.360.cn",
      "icon": "https://kuai.360.cn/favicon.ico",
      "description": "强大的在线视频剪辑工具"
  },
  {
      "name": "Runway",
      "url": "https://runway.ml",
      "icon": "https://runway.ml/favicon.ico",
      "description": "由人工智能驱动的创意工具"
  },
  {
      "name": "Adobe Podcast",
      "url": "https://podcast.adobe.com",
      "icon": "https://podcast.adobe.com/favicon.ico",
      "description": "人工智能音频录制和编辑"
  },
  {
      "name": "Voicemod",
      "url": "https://www.voicemod.net",
      "icon": "https://www.voicemod.net/favicon.ico",
      "description": "免费即时变声器"
  },
  {
      "name": "Soundraw",
      "url": "https://soundraw.io",
      "icon": "https://soundraw.io/favicon.ico",
      "description": "全新的AI音乐平台"
  },
  {
      "name": "LALAL.",
      "url": "https://www.lalal.ai",
      "icon": "https://www.lalal.ai/favicon.ico",
      "description": "提供音乐源分离服务，使用ai技术"
  },
  {
      "name": "Boomy",
      "url": "https://boomy.com",
      "icon": "https://boomy.com/favicon.ico",
      "description": "在几秒钟内创作出原创歌曲"
  },
  {
      "name": "Riffusion",
      "url": "https://riffusion.com",
      "icon": "https://riffusion.com/favicon.ico",
      "description": "一个基于AI生成音乐的项目"
  },
  {
      "name": "polyAI",
      "url": "https://polyai.com",
      "icon": "https://polyai.com/favicon.ico",
      "description": "语音助手，企业智能客服语音服务"
  },
  {
      "name": "MunchAl",
      "url": "",
      "icon": "",
      "description": "自动将长视频转换为数据驱动的短..."
  },
  {
      "name": "Fliki",
      "url": "https://fliki.ai",
      "icon": "https://fliki.ai/favicon.ico",
      "description": "用AI语音将文字变成视频"
  },
  {
      "name": "pollinations",
      "url": "",
      "icon": "",
      "description": "您的引擎 个性化的媒体"
  },
  {
      "name": "LyricStudio",
      "url": "",
      "icon": "",
      "description": "根据你的主题和风格建议独特的歌..."
  },
  {
      "name": "FakeYou",
      "url": "https://fakeyou.com",
      "icon": "https://fakeyou.com/favicon.ico",
      "description": "是一个文本到语音的仙境"
  },
  {
      "name": "Artflow",
      "url": "",
      "icon": "",
      "description": "使用人工智能生成的资产，创建自..."
  },
  {
      "name": "Crypko",
      "url": "",
      "icon": "",
      "description": "可以自动生成动漫人物，且可为动..."
  },
  {
      "name": "Nova A.I.",
      "url": "",
      "icon": "",
      "description": "简单的在线视频编辑软件"
  },
  {
      "name": "Make–A–Video",
      "url": "https://makeavideo.studio",
      "icon": "images/Make-A-Video.png",
      "description": "根据文字提示生成高质量视频"
  },
  {
      "name": "Verw",
      "url": "",
      "icon": "",
      "description": "用AI语音识别自动上字幕"
  },
  {
      "name": "Descript",
      "url": "https://www.descript.com",
      "icon": "images/descript.png",
      "description": "一个音视频编辑器"
  },
  {
      "name": "Uberduck",
      "url": "https://uberduck.ai",
      "icon": "https://uberduck.ai/favicon.ico",
      "description": "开源语音AI社区"
  },
  {
      "name": "AIVA",
      "url": "https://aiva.ai",
      "icon": "https://aiva.ai/favicon.ico",
      "description": "人工智能谱写情感原声音乐"
  },
  {
      "name": "Supertone",
      "url": "",
      "icon": "",
      "description": "使用AI创作音乐、声音和其他声音"
  },
  {
      "name": "Jukebox",
      "url": "https://jukebox.ai",
      "icon": "https://jukebox.ai/favicon.ico",
      "description": "是OpenAI的一款AI音乐生成器"
  },
  {
      "name": "Altered",
      "url": "",
      "icon": "",
      "description": "是一款专业的 AI 变声软件"
  },
  {
      "name": "Unscreen",
      "url": "https://unscreen.com",
      "icon": "https://unscreen.com/favicon.ico",
      "description": "移除视频背景"
  },
  {
      "name": "Topaz video AI",
      "url": "https://topazlabs.com",
      "icon": "https://topazlabs.com/favicon.ico",
      "description": "是一款人工智能视频无损放大软件"
  },
  {
      "name": "通义听悟",
      "url": "https://tongyi.aliyun.com/tingwu",
      "icon": "https://tongyi.aliyun.com/favicon.ico",
      "description": "实时记录交流内容，多语言翻译"
  },
  {
      "name": "一帧秒创",
      "url": "",
      "icon": "",
      "description": "智能视频，绘画，文案创作平台"
  },
  {
      "name": "腾讯智影",
      "url": "https://zenvideo.qq.com",
      "icon": "https://zenvideo.qq.com/favicon.ico",
      "description": "具有文本配音，数字人播报，图文..."
  },
  {
      "name": "万彩微影",
      "url": "https://www.wmvideo.com",
      "icon": "https://www.wmvideo.com/favicon.ico",
      "description": "快速生成短视频"
  },
  {
      "name": "Genmo",
      "url": "https://genmo.art",
      "icon": "https://genmo.art/favicon.ico",
      "description": "图片生成视频AI"
  },
  {
      "name": "Suno",
      "url": "https://suno.ch",
      "icon": "images/suno.jpg",
      "description": "是一个专业高质量的 AI 歌曲和音..."
  },
  {
      "name": "Eleven Labs",
      "url": "https://elevenlabs.io",
      "icon": "https://elevenlabs.io/favicon.ico",
      "description": "文字转音频"
  },
  {
      "name": "Loom",
      "url": "https://www.loom.com",
      "icon": "images/loom.png",
      "description": "视频编辑"
  },
  {
      "name": "VEED.IO",
      "url": "https://veed.io",
      "icon": "https://veed.io/favicon.ico",
      "description": "免费在线视频编辑"
  },
  {
      "name": "VocalRemover",
      "url": "https://vocalremover.org",
      "icon": "https://vocalremover.org/favicon.ico",
      "description": "使用强大的人工智能算法将歌曲中..."
  },
  {
      "name": "InVideo",
      "url": "https://invideo.io",
      "icon": "https://invideo.io/favicon.ico",
      "description": "创建带有文本提示的视频"
  },
  {
      "name": "Vidnoz",
      "url": "https://www.vidnoz.com",
      "icon": "https://www.vidnoz.com/favicon.ico",
      "description": "视频制作工具"
  },
  {
      "name": "Media.io",
      "url": "https://media.io",
      "icon": "https://media.io/favicon.ico",
      "description": "轻松编辑视频"
  },
  {
      "name": "Opus Clip",
      "url": "https://opusclip.com",
      "icon": "https://opusclip.com/favicon.ico",
      "description": "视频编辑"
  },
  {
      "name": "Notta",
      "url": "https://www.notta.ai",
      "icon": "images/notta.png",
      "description": "一款语音转文字的效率工具"
  },
  {
      "name": "Songtell",
      "url": "",
      "icon": "",
      "description": "第一个人工智能生成的歌曲含义库"
  },
  {
      "name": "HeyGen",
      "url": "https://heygen.com",
      "icon": "images/heygen.jpeg",
      "description": "是AI视频翻译工具"
  },
  {
      "name": "pika.art",
      "url": "https://pika.art",
      "icon": "images/pika.jpg",
      "description": "一个将创意转化为AI视频的平台"
  },
  {
      "name": "DeepBrain",
      "url": "https://deepbrain.io",
      "icon": "https://deepbrain.io/favicon.ico",
      "description": "通过简单的文本瞬间创建 AI 生成..."
  },
  {
      "name": "Vizard",
      "url": "",
      "icon": "",
      "description": "用人工智能魔力把长视频变成病毒..."
  },
  {
      "name": "TTSSmaker",
      "url": "",
      "icon": "",
      "description": "一个免费的AI配音平台"
  },
  {
      "name": "Udio",
      "url": "",
      "icon": "",
      "description": "AI音乐生成工具"
  },
  {
      "name": "Beatoven",
      "url": "",
      "icon": "",
      "description": "创建独特的背景音乐"
  },
  {
      "name": "闪剪数字人",
      "url": "",
      "icon": "",
      "description": "是个 AI 数字人口播视频生成平台"
  },
  {
      "name": "绘蛙",
      "url": "",
      "icon": "",
      "description": "简单好用的图文生成平台"
  },
  {
      "name": "即梦AI",
      "url": "",
      "icon": "",
      "description": "一站式AI创作平台，免费AI图片..."
  },
  {
      "name": "Remusic",
      "url": "",
      "icon": "",
      "description": "免费的AI音乐、歌曲创作工具"
  }
]

export default aiTen
